import { Input, message } from 'antd'
import React from 'react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from '../../PageRouting/pageRoutes';

function PhrAccess() {
    const params = useParams();
    const [patientId,setPatientId] = useState(params.id || '');
    const navigate = useNavigate();

    const PatientCode = params.id;
    const handleMemberId = (e) => {
        setPatientId(e.target.value);
    }

    const handleProceed = () => {
        if(!patientId){
            message.error('Please enter member id to proceed!!');
            return;
        }
        navigate(APP_ROUTES.HEALTHSUMMARY,{state:{patientId}});
    }
  return (
    <div className='flex justify-center items-center h-screen'>
        <div className='shadow rounded-lg border border-borderColor p-5'>
            <label htmlFor='memId' className='text-lg font-medium'>Member Id </label>
            <Input id='memId' value={patientId} className="h-10 my-2" onChange={handleMemberId} placeholder='Enter member id'/>
            <div className='text-right pt-2'>
                <button onClick={handleProceed} className="bg-secondaryColor text-white border-brand-secondaryColor border rounded px-5 py-1.5 text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed">Proceed</button>
            </div>
        </div>
    </div>
  )
}

export default PhrAccess